module.exports = __webpack_public_path__ + "img/sanjiao.3bb8ec25.png";